// extracted by mini-css-extract-plugin
module.exports = {"container":"list_container__2qISJ","content":"list_content__S0nuc"};